import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { eventsTypes } from "../constantes/actionTypes"

export const eventsActions = {
    getAllEvents: () => (
        createMiddlewareAction({
            successType: eventsTypes.GET_ALL_EVENTS_SUCCESS,
            failureType: eventsTypes.GET_ALL_EVENTS_FAILURE,
            method: "GET",
            endpoint: endpoints.GET_ALL_EVENTS
        })
    ),
}